import useConvertEstimateToProposal from '@/api/mutations/estimates/useConvertEstimateToProposal';
import useGetProjectEstimate from '@/api/queries/project/useGetProjectEstimate';
import { Button, Tooltip } from '@payaca/ambrosia';
import { FC } from 'react';
import { useHistory } from 'react-router-dom';

type ConvertToProposalButtonProps = {
  projectId: string;
  estimateId: string;
};

/**
 * Primary action to convert an Estimate into a Proposal. Disabled with an
 * explanatory tooltip when the Project already has an active Proposal, since
 * the conversion would be rejected.
 */
const ConvertToProposalButton: FC<ConvertToProposalButtonProps> = (props) => {
  const { projectId, estimateId } = props;

  const { estimate, project } = useGetProjectEstimate(projectId, estimateId);
  const history = useHistory();
  const { mutate: convertToProposal, isPending: isConverting } =
    useConvertEstimateToProposal({
      projectId,
      options: {
        onSuccess: (data) => {
          history.push(
            `/projects/${projectId}/proposals/${data.convertEstimateToProposal.publicId}`
          );
        },
      },
    });

  const hasActiveProposal = project?.hasActiveProposal ?? false;

  return (
    <Tooltip
      tooltipContent="This project already has an active proposal."
      enabled={hasActiveProposal}
    >
      <Button
        size="sm"
        isProcessing={isConverting}
        disabled={!estimate || isConverting || hasActiveProposal}
        onClick={() => convertToProposal({ id: estimateId })}
      >
        Convert to proposal
      </Button>
    </Tooltip>
  );
};

export default ConvertToProposalButton;
